import { DietType } from "../diets";

export const dietsEn: DietType[] = [
    {
        id: "keto",
        name: "Keto",
        description: "High-fat, low-carb diet",
        objective: "Weight loss and blood sugar regulation",
    },
    {
        id: "vegetarian",
        name: "Vegetarian",
        description: "Plant-based nutrition rich in nutrients",
        objective:
            "General health improvement and environmental impact reduction",
    },
    {
        id: "paleo",
        name: "Paleo",
        description: "Whole foods based on ancestral eating",
        objective: "Weight loss and inflammation reduction",
    },
    {
        id: "lowcarb",
        name: "Low-Carb",
        description: "Low carbohydrate diet with proteins and fats",
        objective: "Weight loss or maintenance",
    },
    {
        id: "mediterranean",
        name: "Mediterranean",
        description: "Diet based on whole foods, olive oil, fish and nuts",
        objective: "Cardiovascular health and maintenance",
    },
    {
        id: "intermittentfasting",
        name: "Intermittent Fasting",
        description: "Alternating periods of fasting and eating",
        objective: "Caloric control and fat loss",
    },
    {
        id: "highprotein",
        name: "High Protein",
        description: "High protein diet to preserve muscle mass",
        objective: "Muscle development and maintenance",
    },
    {
        id: "zone",
        name: "Zone",
        description: "Balance of 40% carbs, 30% protein and 30% fat",
        objective: "Blood sugar stabilization and weight control",
    },
    {
        id: "vegan",
        name: "Vegan",
        description: "Completely plant-based diet",
        objective: "General health and environmental sustainability",
    },
    {
        id: "carnivore",
        name: "Carnivore",
        description: "Diet based only on meat, fish and animal products",
        objective: "Extreme weight loss and inflammation reduction",
    },
    {
        id: "flexible",
        name: "Flexible Diet",
        description: "Flexible eating that respects macronutrients",
        objective: "Flexibility for aesthetic or sports goals",
    },
    {
        id: "dash",
        name: "DASH",
        description: "Diet rich in fruits, vegetables and whole grains",
        objective: "Cardiovascular health and hypertension reduction",
    },
];
